export enum UniformStatusTypes {
  APPROVED = 'approved',
  REJECTED = 'rejected'
}
